'use client';

import {useState} from 'react';
import {suggestCompany} from 'iq-companies/api';

// "Don't see your company?" capture, shown from search_bar.tsx when a query has zero
// typeahead results. Wired to the real, anonymous-friendly POST /v1/companies/suggest
// (plan § 1e) — works for logged-out visitors too since /companies is anonymous-friendly
// by design.
export function RequestCompanyForm({defaultName}: {defaultName: string}) {
  const [name, setName] = useState(defaultName);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  if (submitted) {
    return (
      <p className='px-4 py-3 text-sm text-gray-600'>
        Thanks — we&apos;ll look into adding {name || 'this company'}.
      </p>
    );
  }

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        if (!name.trim() || submitting) return;
        setSubmitting(true);
        try {
          await suggestCompany(name.trim());
          setSubmitted(true);
        } finally {
          setSubmitting(false);
        }
      }}
      className='flex flex-col gap-2 px-4 py-3'>
      <p className='text-sm text-gray-600'>Don&apos;t see your company?</p>
      <div className='flex gap-2'>
        <input
          type='text'
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder='Company name'
          className='min-w-0 flex-1 rounded-md border border-gray-300 px-3 py-1.5 text-sm focus:outline-none focus:ring-1 focus:ring-gray-400'
        />
        <button
          type='submit'
          disabled={submitting}
          className='rounded-md bg-iq-orange px-3 py-1.5 text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-60'>
          {submitting ? 'Sending…' : 'Request'}
        </button>
      </div>
    </form>
  );
}
